import type { ButtonType } from 'antd/es/button';
import { IBaseWidget } from '../../../IBaseWidget';
import { ICodeWidget } from '../../../ICodeWidget';
import { IBaseLayoutOptions, WidgetType } from '../../../Widget';
import { IconType } from '../buttons/icons/Icons';
import { ButtonAlign } from '../buttons/types/ButtonEnums';

export interface IConfirmWidgetLayout extends IBaseLayoutOptions {
  confirmIcon?: IconType;
  confirmText?: string;
  confirmButtonType?: ButtonType;
  editIcon?: IconType;
  editText?: string;
  editButtonType?: ButtonType;
  alignEnd?: boolean;
  buttonsAlign?: ButtonAlign;
}

/**
 * Widget conferma
 */
export interface IConfirmWidget extends IBaseWidget, ICodeWidget {
  id: string;
  type: WidgetType.Confirm;
  layout?: IConfirmWidgetLayout;
}

export enum ConfirmWidgetValue {
  /** Stato iniziale. */
  Unconfirmed = 0,
  /** L'utente ha confermato di voler mantenere il default */
  ConfirmedDefault = 1,
  /** L'utente ha confermato di voler modificare il default */
  ConfirmedModified = 2,
  /** L'utente vuole modificare il campo ma non ha ancora confermato */
  Editing = 3,
}
